import axios from 'axios'
import store from '../store/index'
import router from '../router';

const Axios = axios.create({
  baseURL: 'https://wfl.blackhorse-one.com', //'http://localhost:3000',
  headers: {
    Authorization: 'Bearer ' + store.getters.getAuthToken,
    'Accept-Language': 'en'
  }
})

Axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 403) {
    router.push('/login')
  }
  return Promise.reject(error)
})

Axios.interceptors.request.use(config => {
  config.headers.Authorization = 'Bearer ' + store.getters.getAuthToken
  return config
}, error => {
  return Promise.reject(error)
})

export default Axios